/* global wpApiSettings */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { wpBase } from '../api/base';
import { setUser } from '../slices/longTermHousingRentals.slice';

// CURRENT LOGGED IN USER
const fetchCurrUser = createAsyncThunk(
  'user/fetch',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await wpBase.get(`/wp-json/wp/v2/users/me`, {
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': wpApiSettings.nonce,
        },
      });

      if (response.status === 200 || response.status === 201) {
        dispatch(setUser(response.data));
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);
      return rejectWithValue(error.message);
    }
  }
);

// REPLY TO LISTING
const replyListing = createAsyncThunk(
  'user/replyListing',
  async (
    { recipientId, listingId, message, attachment },
    { rejectWithValue }
  ) => {
    try {
      // Prepare the form data
      const formData = new FormData();
      formData.append('recipient', recipientId);
      formData.append('listing', listingId);
      formData.append('text', message);
      if (attachment) {
        formData.append('attachment', attachment);
      }

      const response = await wpBase.post(
        `/wp-json/hivepress/v1/messages`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-WP-Nonce': wpApiSettings.nonce,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error('Error replying to listing:', error);
      return rejectWithValue(error.message);
    }
  }
);

// WRITE REVIEW
const writeReview = createAsyncThunk(
  'user/writeReview',
  async ({ listingId, rating, reviewText }, { rejectWithValue }) => {
    // Prepare the form data
    const formData = new FormData();
    formData.append('listing', listingId);
    formData.append('rating', rating);
    formData.append('text', reviewText);

    try {
      const response = await wpBase.post(
        '/wp-json/hivepress/v1/reviews',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-WP-Nonce': wpApiSettings.nonce,
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
        return {
          rating,
          data: response.data,
        };
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error('Error replying to listing:', error);
      return rejectWithValue(error.message);
    }
  }
);

// REPORT LISTING
const reportListing = createAsyncThunk(
  'user/reportListing',
  async ({ listingId, details }, { rejectWithValue }) => {
    // Prepare the form data
    const formData = new FormData();
    formData.append('details', details);

    try {
      const response = await wpBase.post(
        `/wp-json/hivepress/v1/listings/${listingId}/report`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-WP-Nonce': wpApiSettings.nonce,
          },
        }
      );
      if (response.status === 200 || response.status === 201) {
        return response.data;
      } else {
        return rejectWithValue(`Unexpected status code: ${response.status}`);
      }
    } catch (error) {
      console.error('Error replying to listing:', error);
      return rejectWithValue(error.message);
    }
  }
);

export { fetchCurrUser, replyListing, writeReview, reportListing };
